import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import ServiceResult, { Loaders } from "../../UI/ServiceResult/ServiceResult";
import useService from "../../Hooks/useService";
import PipelineReportService from "../../../Services/PipelineReport.service";
import CustomCard from "../../UI/CustomCard/CustomCard";
import AnyStageConversionPipelineWidgetChart from "./AnyStageConversionPipelineWidgetChart";
import { OpportunitySourceMultiSearch } from "../../Presentational/OpportunitySource/OpportunitySourceSearch";
const AnyStagesConversionPipelineWidget = ({ pipeline, className, }) => {
    const [config, setConfig] = React.useState({
        stages: pipeline.stages,
        opportunitySources: [],
    });
    React.useEffect(() => {
        setConfig((c) => (Object.assign(Object.assign({}, c), { stages: pipeline.stages })));
    }, [pipeline.stages]);
    const [conversionState, loadDuration] = useService(PipelineReportService.anyStagesConversionCounts);
    React.useEffect(() => {
        loadDuration({
            stageIds: config.stages.map((stage) => stage.id),
            opportunitySourceIds: config.opportunitySources.map((source) => source.id),
        });
    }, [loadDuration, config]);
    return (_jsx(CustomCard, { title: "Any Stage Conversion", className: className, children: _jsxs("div", { className: "card-body", children: [_jsx("div", { className: "mb-3", style: { width: 400 }, children: _jsx(OpportunitySourceMultiSearch, { placeholder: "Opportunity Sources", "aria-label": "Opportunity Sources", value: config.opportunitySources, onChange: (sources) => {
                            setConfig((c) => (Object.assign(Object.assign({}, c), { opportunitySources: sources })));
                        } }) }), _jsx(ServiceResult, { state: conversionState, loader: Loaders.overlay(), children: (conversions) => (_jsx(AnyStageConversionPipelineWidgetChart, { conversionData: conversions })) })] }) }));
};
export default AnyStagesConversionPipelineWidget;
